import { render, staticRenderFns } from "./mdedge.vue?vue&type=template&id=5513fd10&scoped=true&v-once=true"
import script from "./mdedge.vue?vue&type=script&lang=js"
export * from "./mdedge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5513fd10",
  null
  
)

export default component.exports